/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { getState, } from '../twd/twd'
import { getDefaultAcctNo, MODES } from './use-order-ticket'


const Last = getState('order-ticket-form.last', {
    ts: 0,
})

export const resetLastOrderForm = ({ts=0} = {}) => {
    Last.reset()
    Last.set({ts})
}

export default ({
    acctNo_='', cusip_='', action_='', qty_='', price_='', yld_='',
    sourceAction_='', actionSubset_='',
} = {}) => {

    const [acctNo, setAcctNo_] = React.useState(Last.value.acctNo || acctNo_ || getDefaultAcctNo())
    const setAcctNo = React.useCallback((acctNo) => {
        Last.set({acctNo})
        setAcctNo_(acctNo)
    }, [])

    const [mode, setMode_] = React.useState(Last.value.mode
        || getMode({action:action_, sourceAction_, actionSubset_}))
    const setMode = React.useCallback((mode) => {
        Last.set({mode})
        setMode_(mode)
    }, [])

    const [cusip, setCusip_] = React.useState(Last.value.cusip || cusip_ || '')
    const setCusip = React.useCallback((cusip) => {
        Last.set({cusip})
        setCusip_(cusip)
    }, [])

    const [action, setAction_] = React.useState(Last.value.action || action_ || 'B')
    const setAction = React.useCallback((action) => {
        Last.set({action})
        setAction_(action)
        setIsRfq(action==='W' || action==='F' || actionSubset_==='WF')
    }, [])

    const [isRfq, setIsRfq_] = React.useState(Last.value.isRfq
        || action_ ==='W' || action_==='F' || actionSubset_==='WF')
    const setIsRfq = React.useCallback((isRfq) => {
        Last.set({isRfq})
        setIsRfq_(isRfq)
    }, [])

    const [qty, setQty_] = React.useState(Last.value.qty || qty_|| '')
    const setQty = React.useCallback((qty) => {
        Last.set({qty})
        setQty_(qty)
    }, [])

    const [price, setPrice_] = React.useState(Last.value.price || price_ || '')
    const setPrice = React.useCallback((price) => {
        Last.set({price})
        setPrice_(price)
    }, [])

    const [yld, setYld_] = React.useState(Last.value.yld  || yld_ || '')
    const setYld = React.useCallback((yld) => {
        Last.set({yld})
        setYld_(yld)
    }, [])

    const [priceOrYield, setPriceOrYield_] = React.useState(Last.value.priceOrYield || 1)
    const setPriceOrYield = React.useCallback((priceOrYield) => {
        Last.set({priceOrYield})
        setPriceOrYield_(priceOrYield)
    }, [])

    const [priceEl, setPriceEl] = React.useState(null)
    const [yieldEl, setYieldEl] = React.useState(null)

    const [bestPrice, setBestPrice_] = React.useState(Last.value.bestPrice || null)
    const setBestPrice = React.useCallback((bestPrice) => {
        Last.set({bestPrice})
        setBestPrice_(bestPrice)
    }, [])

    const [bestYield, setBestYield_] = React.useState(Last.value.bestYield  || null)
    const setBestYield = React.useCallback((bestYield) => {
        Last.set({bestYield})
        setBestYield_(bestYield)
    }, [])

    const [noMarketRfq, setNoMarketRfq] = React.useState(false)

    const reset = ({acctNo, cusip, action, qty, price, yld, actionSubset_, sourceAction_}) => {
        Last.reset()
        setAcctNo(acctNo || getDefaultAcctNo())
        setCusip(cusip)
        setAction(action)
        setQty(qty)
        setPrice(price)
        setYld(yld)
        setBestPrice(null)
        setBestYield(null)
        setNoMarketRfq(false)
        setMode(getMode({action, actionSubset_, sourceAction_}))
        setIsRfq(action==='W' || action==='F' || actionSubset_==='WF')
    }

    return {
        acctNo, setAcctNo,
        mode, setMode,
        cusip, setCusip,
        action, setAction,
        isRfq,
        qty, setQty,
        price, setPrice,
        yld, setYld,
        priceOrYield, setPriceOrYield,
        bestPrice, setBestPrice,
        bestYield, setBestYield,
        noMarketRfq, setNoMarketRfq,
        reset,
        priceEl, setPriceEl,
        yieldEl, setYieldEl,
    }
}


const getMode = ({action='', sourceAction_, actionSubset_} = {}) => {
    return sourceAction_ ==='Z' || sourceAction_ ==='Y' ? MODES.ORDER_Z :
        actionSubset_ ==='WF' ? MODES.RFQ :
        action.length === 1 ? MODES.ORDER :
        MODES.NEW
}